import React from "react";
import CleanNavBar from "../Layout/CleanNavBar";
import CleanFooter from "../Layout/CleanFooter";

const ClientAgreement = () => {
  return (
    <div className="page-wrapper">
      <CleanNavBar />
      <div className="page-content">
        <div className="page-header">
          <h1>Corporate Account Agreement</h1>
        </div>
        <div className="clean-container">
          <div className="content-section">
            <p className="last-updated">Version 2.0 - January 2025</p>
            
            <h2>Corporate Transportation Agreement</h2>
            <p>
              This Agreement is entered into between GlobeCab International Ltd. ("GlobeCab") 
              and the Corporate Client for the provision of transportation services.
            </p>
            
            <h2>1. Service Options</h2>
            <h3>1.1 On-Demand Services</h3>
            <p>Book rides as needed with corporate billing and reporting.</p>
            
            <h3>1.2 Dedicated Fleet</h3>
            <p>Reserved vehicles for exclusive corporate use during business hours.</p>
            
            <h3>1.3 Monthly Packages</h3>
            <p>Pre-purchased ride credits with volume discounts and priority booking.</p>
            
            <h2>2. Service Standards</h2>
            <ul>
              <li>Average pickup time: 5-10 minutes</li>
              <li>On-time arrival guarantee: 96%</li>
              <li>24/7 dedicated support line</li>
              <li>Monthly usage reports and analytics</li>
            </ul>
            
            <h2>3. Corporate Pricing</h2>
            <table className="fee-table">
              <tr>
                <th>Service Type</th>
                <th>Discount</th>
              </tr>
              <tr>
                <td>Standard rides</td>
                <td>10% off regular fares</td>
              </tr>
              <tr>
                <td>Airport transfers</td>
                <td>15% off + flat rates</td>
              </tr>
              <tr>
                <td>Monthly commitment ($5000+)</td>
                <td>20% volume discount</td>
              </tr>
              <tr>
                <td>Dedicated fleet services</td>
                <td>Custom pricing</td>
              </tr>
            </table>
            
            <h2>4. Service Guarantees</h2>
            <p>
              On-time pickup guarantee or 20% discount on affected ride. Priority support 
              response within 2 minutes. Dedicated account manager for accounts over $10,000/month.
            </p>
            
            <h2>5. Billing and Payment</h2>
            <p>
              Monthly invoicing with NET-30 payment terms. Detailed trip reports with cost center 
              allocation. Integration with expense management systems available.
            </p>
            
            <h2>6. Data and Reporting</h2>
            <p>
              Monthly usage analytics, carbon footprint reporting, and employee travel patterns 
              provided. All data remains confidential and is not shared with third parties.
            </p>
            
            <h2>7. Compliance and Ethics</h2>
            <p>
              Both parties commit to ethical recruitment practices, including non-discrimination, 
              data privacy compliance, and fair employment practices.
            </p>
            
            <h2>8. Dispute Resolution</h2>
            <p>
              Disputes shall be resolved through mediation, then arbitration under SIAC rules in Singapore.
            </p>
            
            <h2>Contact for Agreement Execution</h2>
            <p>
              To execute this agreement, contact: 
              <a href="mailto:contracts@ascendtalentrecruitment.com"> contracts@ascendtalentrecruitment.com</a>
            </p>
          </div>
        </div>
      </div>
      <CleanFooter />
    </div>
  );
};

export default ClientAgreement;